import Typography from "@mui/material/Typography";
import { FC } from "react";
import Switch from "shared/components/Form/Switch";
import { COLOR_BLACK, COLOR_GREY_9 } from "shared/theme/colors";
import { StyledConfigItem } from "./styled";

export type ConfigItemProps = {
  title: string;
  value?: boolean;
  handleToggle: () => void;
};

const ConfigItem: FC<ConfigItemProps> = ({ title, value, handleToggle }) => {
  return (
    <StyledConfigItem>
      <Typography
        textTransform={"capitalize"}
        variant="bodyMRegular"
        color={COLOR_GREY_9}
      >
        Show {title}:
      </Typography>
      <Typography color={COLOR_BLACK} variant="bodyMRegular">
        {value ? "True" : "False"}
      </Typography>
      <Switch value={Boolean(value)} onChange={handleToggle} />
    </StyledConfigItem>
  );
};

export default ConfigItem;
